import { ReduxAction } from 'actions';
import {
    ListActionType, UpdateListOptionsType,
} from '@actions/listActions';
import { OrderDirection } from '@api/graphql/types';

export interface ListOptionType {
    count: number;
    page: number;
    sortBy: {
        field: any;
        direction: OrderDirection;
    };
    filters?: any;
}

export interface ListsReducer {
    [key: string]: ListOptionType;
}

const initialState: ListsReducer = {};

export default function (state: ListsReducer = initialState, action: ReduxAction) {
    switch (action.type) {
        case ListActionType.updateListOptions:
            const newState = {...state};
            newState[(action as UpdateListOptionsType).payload.listName] = (action as UpdateListOptionsType).payload.options;
            return newState;
        default:
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/listReducer.ts